// https://www.bankid.com/assets/bankid/rp/bankid-relying-party-guidelines-v3.6.pdf
// See page 22 for the list of statuses and hint codes
export enum BankIdCollectStatus {
  pending = 'pending',
  failed = 'failed',
  complete = 'complete',
}

export enum BankIdCollectHintCode {
  outStandingTransaction = 'outStandingTransaction',
  started = 'started',
  userSign = 'userSign',
  noClient = 'noClient',
}
